import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';

const API = process.env.REACT_APP_API_URL;

export default function CrmUsuariosAdmin() {
  const [usuarios, setUsuarios] = useState([]);
  const [vendedores, setVendedores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [nuevoIdVendedor, setNuevoIdVendedor] = useState('');
  const [nuevoRol, setNuevoRol] = useState('vendedor');
  const [nuevoCrm, setNuevoCrm] = useState('');

  useEffect(() => { load(); loadVendedores(); }, []);

  const load = async () => {
    try {
      const res = await fetch(`${API}/prod/crm_usuarios_admin`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'list' }),
      });
      const data = await res.json();
      const body = typeof data.body === 'string' ? JSON.parse(data.body) : data.body || data;
      setUsuarios(Array.isArray(body) ? body : []);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  // Cargar catalogo de vendedores (id + nombre) para los selectores
  const loadVendedores = async () => {
    try {
      const res = await fetch(`${API}/prod/vendedores_admin`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'list' }),
      });
      const data = await res.json();
      const body = typeof data.body === 'string' ? JSON.parse(data.body) : data.body || data;
      const lista = Array.isArray(body) ? body : [];
      // ordenar por id ascendente para que sea facil de buscar
      lista.sort((a, b) => Number(a.id_vendedor) - Number(b.id_vendedor));
      setVendedores(lista);
    } catch (e) { console.error('No se pudo cargar vendedores:', e); }
  };

  // Nombre legible de un vendedor por su id (para la lista de usuarios)
  const nombreVendedor = (id) => {
    const v = vendedores.find(x => String(x.id_vendedor) === String(id));
    return v ? v.nombre : '';
  };

  const addUsuario = async () => {
    if (!nuevoIdVendedor || isNaN(Number(nuevoIdVendedor))) {
      toast.warn('id_vendedor es requerido y debe ser numérico');
      return;
    }
    if (!nuevoRol) {
      toast.warn('Selecciona un rol');
      return;
    }
    try {
      await fetch(`${API}/prod/crm_usuarios_admin`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          action: 'add',
          id_vendedor: Number(nuevoIdVendedor),
          rol: nuevoRol,
          idvendedor_crm: nuevoCrm || '',
          activo: 1,
        }),
      });
      toast.success(`Usuario ${nuevoIdVendedor} agregado`);
      setNuevoIdVendedor('');
      setNuevoRol('vendedor');
      setNuevoCrm('');
      load();
    } catch (e) { console.error(e); toast.error('Error al agregar usuario'); }
  };

  const updateRol = async (id, rol) => {
    try {
      await fetch(`${API}/prod/crm_usuarios_admin`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'update', id, rol }),
      });
      toast.success('Rol actualizado');
      load();
    } catch (e) { console.error(e); toast.error('Error al actualizar rol'); }
  };

  const updateCrm = async (id, idvendedor_crm) => {
    try {
      await fetch(`${API}/prod/crm_usuarios_admin`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'update', id, idvendedor_crm }),
      });
      toast.success('idvendedor_crm actualizado');
      load();
    } catch (e) { console.error(e); toast.error('Error al actualizar idvendedor_crm'); }
  };

  const toggleActivo = async (id, activo) => {
    try {
      await fetch(`${API}/prod/crm_usuarios_admin`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'toggle', id, activo: activo ? 0 : 1 }),
      });
      toast.success('Estado actualizado');
      load();
    } catch (e) { console.error(e); toast.error('Error al cambiar estado'); }
  };

  if (loading) return <div style={{ padding: 20, textAlign: 'center', color: '#9ca3af' }}>Cargando usuarios...</div>;

  const inputStyle = {
    padding: '8px', borderRadius: '8px', border: '1px solid #ccc',
    fontSize: '14px',
  };

  return (
    <div style={{ marginTop: '20px' }}>
      <h2>👥 Usuarios CRM</h2>

      <div style={{ background: '#fef9c3', borderRadius: '14px', padding: '14px', marginBottom: '20px', fontSize: '13px', color: '#92400e', lineHeight: '1.5' }}>
        <strong>Administra quién puede entrar al CRM y con qué permisos.</strong>
        <br />Los admins ven los paneles de administración. idvendedor_crm (opcional) asigna el CRM de otro vendedor.
      </div>

      {/* Alta de usuario */}
      <div style={{
        background: '#fff', borderRadius: '12px', padding: '14px',
        marginBottom: '20px', border: '1px solid #e2e8f0',
        display: 'flex', flexWrap: 'wrap', gap: '10px', alignItems: 'flex-end',
      }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <label style={{ fontSize: 12, color: '#6b7280' }}>Vendedor</label>
          <select
            value={nuevoIdVendedor}
            onChange={(e) => setNuevoIdVendedor(e.target.value)}
            style={{ ...inputStyle, minWidth: '220px' }}
          >
            <option value="">Selecciona un vendedor…</option>
            {vendedores.map(v => (
              <option key={v.id_vendedor} value={v.id_vendedor}>
                {v.id_vendedor} · {v.nombre || 's/nombre'}
              </option>
            ))}
          </select>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <label style={{ fontSize: 12, color: '#6b7280' }}>rol</label>
          <select value={nuevoRol} onChange={(e) => setNuevoRol(e.target.value)} style={inputStyle}>
            <option value="vendedor">vendedor</option>
            <option value="admin">admin</option>
            <option value="superadmin">superadmin</option>
          </select>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <label style={{ fontSize: 12, color: '#6b7280' }}>CRM de (opcional)</label>
          <select
            value={nuevoCrm}
            onChange={(e) => setNuevoCrm(e.target.value)}
            style={{ ...inputStyle, minWidth: '220px' }}
          >
            <option value="">— Su propio vendedor —</option>
            {vendedores.map(v => (
              <option key={v.id_vendedor} value={v.id_vendedor}>
                {v.id_vendedor} · {v.nombre || 's/nombre'}
              </option>
            ))}
          </select>
        </div>
        <button onClick={addUsuario} style={{
          padding: '10px 16px', background: '#1b2938', color: '#fff',
          border: 'none', borderRadius: '8px', cursor: 'pointer',
          fontSize: '14px', fontWeight: '600',
        }}>
          Agregar
        </button>
      </div>

      {/* Lista de usuarios */}
      <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
        {usuarios.map(u => (
          <div key={u.id} style={{
            display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap',
            padding: '12px 14px', background: '#fff', borderRadius: '12px',
            marginBottom: '8px', border: '1px solid #e2e8f0',
          }}>
            <div style={{ flex: 1, minWidth: 140 }}>
              <div style={{ fontWeight: 700, fontSize: 14, color: '#1b2938' }}>
                {u.id_vendedor} · {u.nombre || nombreVendedor(u.id_vendedor) || u.id_vendedor}
              </div>
              <div style={{ fontSize: 12, color: '#6b7280' }}>
                CRM: {u.idvendedor_crm ? `${u.idvendedor_crm} · ${nombreVendedor(u.idvendedor_crm) || ''}` : 'propio'}
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <label style={{ fontSize: 11, color: '#9ca3af' }}>rol</label>
              <select
                value={u.rol || 'vendedor'}
                onChange={(e) => updateRol(u.id, e.target.value)}
                style={inputStyle}
              >
                <option value="vendedor">vendedor</option>
                <option value="admin">admin</option>
                <option value="superadmin">superadmin</option>
              </select>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <label style={{ fontSize: 11, color: '#9ca3af' }}>CRM de</label>
              <select
                value={u.idvendedor_crm || ''}
                style={{ ...inputStyle, minWidth: '180px' }}
                onChange={(e) => {
                  if (e.target.value !== (u.idvendedor_crm || '')) {
                    updateCrm(u.id, e.target.value);
                  }
                }}
              >
                <option value="">— Su propio vendedor —</option>
                {vendedores.map(v => (
                  <option key={v.id_vendedor} value={v.id_vendedor}>
                    {v.id_vendedor} · {v.nombre || 's/nombre'}
                  </option>
                ))}
              </select>
            </div>
            <button onClick={() => toggleActivo(u.id, u.activo)} style={{
              padding: '8px 12px', borderRadius: '8px', cursor: 'pointer',
              border: '1px solid #e2e8f0', fontSize: '13px', fontWeight: '600',
              background: u.activo ? '#dcfce7' : '#fee2e2',
              color: u.activo ? '#166534' : '#991b1b',
            }}>
              {u.activo ? 'Activo' : 'Inactivo'}
            </button>
          </div>
        ))}
      </div>

      <div style={{ height: 80 }} />
    </div>
  );
}
